function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Artboard",
  stroke: "current",
  strokeWidth: 1,
  fill: "current",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(2, 0)",
  fill: "current",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.4,0 L26,7.6 L26,30 L0,30 L0,0 L18.4,0 Z M17.571,2 L2,2 L2,28 L24,28 L24,8.429 L17.571,2 Z",
  id: "Rectangle"
})), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "current",
  x: 6,
  y: 5,
  width: 7,
  height: 2,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy",
  fill: "current",
  x: 6,
  y: 11,
  width: 13,
  height: 2,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-2",
  fill: "current",
  x: 6,
  y: 15,
  width: 18,
  height: 2,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-3",
  fill: "current",
  x: 6,
  y: 19,
  width: 18,
  height: 2,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-4",
  fill: "current",
  x: 6,
  y: 23,
  width: 18,
  height: 2,
  rx: 1
}));

function SvgIconDocuments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocuments);
export default __webpack_public_path__ + "static/media/icon_documents.abb63dda.svg";
export { ForwardRef as ReactComponent };